import { render, staticRenderFns } from "./AdminSettingSafetyWatermark.vue?vue&type=template&id=3aa0186a&scoped=true&"
import script from "./AdminSettingSafetyWatermark.vue?vue&type=script&lang=js&"
export * from "./AdminSettingSafetyWatermark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa0186a",
  null
  
)

export default component.exports